var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStoptagon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  className: "_dm-svg",
  focusable: "false",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5 0L0 5v6l5 5h6l5-5V5l-5-5H5zm5.652 3.58l1.767 1.768L9.768 8l2.651 2.652-1.767 1.767L8 9.768l-2.652 2.651-1.767-1.767L6.232 8 3.581 5.348l1.767-1.767L8 6.232l2.652-2.651z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStoptagon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Stoptagon.f0aeb32946019eae04657f459ce38ad5.svg";